import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(null);

  const checkAllowed = async (userId) => {
    const { data } = await supabase
      .from('allowed_users')
      .select('user_id')
      .eq('user_id', userId)
      .single();
    setIsAllowed(!!data);
  };

  useEffect(() => {
    supabase.auth.getSession()
      .then(({ data: { session } }) => {
        const u = session?.user ?? null;
        setUser(u);
        if (u) {
          checkAllowed(u.id);
        } else {
          setIsAllowed(null);
        }
      })
      .catch(() => {
        setUser(null);
        setIsAllowed(null);
      })
      .finally(() => {
        setAuthLoading(false);
      });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') {
        setUser(null);
        setIsAllowed(null);
      } else {
        const u = session?.user ?? null;
        setUser(u);
        if (u) {
          checkAllowed(u.id);
        } else {
          setIsAllowed(null);
        }
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const signInWithGoogle = () =>
    supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    });

  const signOut = () => supabase.auth.signOut();

  const redeemCode = async (code) => {
    const { data } = await supabase.rpc('redeem_invite_code', {
      p_code: code.trim().toUpperCase(),
      p_user_id: user.id,
    });
    if (data) setIsAllowed(true);
    return data;
  };

  return { user, authLoading, isAllowed, signInWithGoogle, signOut, redeemCode };
};
